export enum ColumnSort {
  Ascending = 'asc',
  Descending = 'desc',
  None = '',
}
